module.exports = __webpack_public_path__ + "static/media/detectDataImage4_en.330877ad.png";